import React from 'react'
import styled from 'styled-components';
import resume from '../img/resume.png';
import PrimaryButton from './PrimaryButton';


export default function ImageSection() {
    return (
        <ImageSectionStyled>
            <div className="left-content">
                <img src={resume} alt="resume" />
            </div>
            <div className="right-content">
                <div className="sub-title">
                    <h4>I am Manik <span>Kumar Shil</span></h4>
                </div>
                <p className="paragraph">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi suscipit in quaerat perferendis id quidem eius! Sapiente dolor illum, debitis odit, reprehenderit laudantium quidem dolorum nemo totam vitae tenetur veritatis?

                </p>
                <div className="about-info">
                    <div className="info-title">
                        <p>Full Name</p>
                        <p>Age</p>
                        <p>Nationallity</p>
                        <p>Language</p>
                        <p>Location</p>
                        <p>Services</p>

                    </div>
                    <div className="info">
                        <p>: Manik Kumar Shil</p>
                        <p>: 28</p>
                        <p>: Bangladeshi</p>
                        <p>: Bangla, English</p>
                        <p>: 368 Duhui Road, Minhang, Shanghai, China</p>
                        <p>: Sharepoint Developer</p>

                    </div>

                </div>
                <PrimaryButton title={'Download CV'}/>
            </div>

            
        </ImageSectionStyled>
      

    )
}

const ImageSectionStyled = styled.div`
 display: flex;
 margin-top:5rem; 

 .left-content{

  
    img{
        width:90%;
    
        object-fit: cover;

    }

 }
 .right-content{
     padding-bottom:1.4rem;

     h4{
         font-size:2rem;
         color:var(--white-color);
         span{
             font-size: 2rem;
         }
     }
     .paragraph{
         padding: 1rem 0;
     }
     .about-info{
         display: flex;
         .info-title{
             padding-right: 3rem;
             font-weight: 500;
         }
         .info-title, .info {
             p{
                 padding: .4rem 0;
             }
         }
     }

 }

`